import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { OrganizationBasic } from '../models';

import { ArticleRangeService } from './article-range.service';

@Injectable()
export class OrganizationsCacheService {
  private readonly _availableOrganizations$: Observable<readonly OrganizationBasic[]>;

  constructor(private readonly articleRangeService: ArticleRangeService) {
    this._availableOrganizations$ = this.articleRangeService
      .getAvailableOrganizations()
      .pipe(takeUntilDestroyed(), shareReplay(1));
  }

  public getAvailableOrganizations(): Observable<readonly OrganizationBasic[]> {
    return this._availableOrganizations$;
  }
}
